/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';

class InputFieldUpdateMixin {
    static requestDelete(e) {
		let constants = this.props.app.config.constants,
			routeId = this.props.router.params.routeId,
			inputId = this.props.router.params.inputId;

        // delete is confirmed at this point... engage.

        e.preventDefault();

		// if this is a simple route, delete the route, otherwise just delete the feed
		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
			RouteActions.deleteRoute(routeId);
		} else {
			RouteActions.deleteInput(inputId);
		}
	}

	static requestTextRuleChange(action, id, rule) {
		let newRules = _.clone(this.state.input.rules),
			newInput = _.clone(this.state.input),
			tempRules = [],
			i = 0;

        if (!Array.isArray(newRules)) {
            newRules = [];
        }

		switch (action) {
			case 'add':
				if (newRules.length) {
                    let canAdd = true;
                    for (i = 0; i < newRules.length; ++i) {
                        if (newRules[i].deleted === undefined || newRules[i].deleted === false) {
                            if (newRules[i].search === '' &&
        						newRules[i].replace === '') {
        						canAdd = false
        					}
                        }
                    }
                    if (!canAdd) {
						return;
                    }
				}
				newRules.push({
					action: 'replace',
					search: '',
					'case': false,
					replace: '',
					fields: ['title', 'body'],
					find: 'any'
				});
				break;

			case 'update':
				newRules[id] = rule;
				break;

			case 'delete':
                // set a flag on the object and only render it if deleted
                // isn't present. this is due to react expecting state objects to be
                // immutable and in this case we're mutating state before updating the object
                rule = _.clone(newRules[id]);
                rule.deleted = true;
                newRules[id] = rule;
				break;

			default:
				return;
		}
		newInput.rules = newRules;

		this.setState({
			input: newInput
		});
	}

	static requestScheduleChange(action, schedule) {
		var newInput = _.clone(this.state.input),
			newSchedules = [],
			current = {},
			i = 0,
			tempID = new Date().getTime();

		switch (action) {
			case 'add':
				newSchedules = this.state.input.sched;
				newSchedules.unshift({
					s_id: 'sch-' + tempID,
					s_days: 0,
					s_startTime: '00:00:00',
					s_endTime: '23:59:59',
                    s_tagID: 0
				});
				break;

			case 'update':
			case 'remove':
				for (i = 0; i < this.state.input.sched.length; ++i) {
					current = this.state.input.sched[i];
					if (current.s_id === schedule.s_id) {
						if (action === 'remove') {
							continue;
						} else {
							newSchedules.push(schedule);
						}
					} else {
						newSchedules.push(current);
					}
				}
				break;

			default:
				return;
		}

		newInput.sched = newSchedules;

		this.setState({
			input: newInput
		});
	}
}

export default InputFieldUpdateMixin;
